import {
  DevicePhoneMobileIcon,
  ComputerDesktopIcon,
  HeartIcon,
  MusicalNoteIcon,
  SparklesIcon,
  TvIcon,
  CpuChipIcon,
  WifiIcon,
  ShieldCheckIcon,
  BookOpenIcon,
  HomeIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";

const bestSellers = [
  {
    name: "Kindle & eBooks",
    icon: BookOpenIcon,
    description: "Best-selling digital reads",
    color: "bg-blue-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=29ab19e698d285fbc261a7973ca1445f&camp=1789&creative=9325&node=133140011",
  },
  {
    name: "Baby & Nursery",
    icon: HeartIcon,
    description: "Top picks for little ones",
    color: "bg-pink-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=7df18775c90b8950278d8ce5f2655b49&camp=1789&creative=9325&node=165796011",
  },
  {
    name: "Tech & Electronics",
    icon: CpuChipIcon,
    description: "Latest gadgets & gear",
    color: "bg-purple-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=5a964a8694765673a8e44e28256d26ed&camp=1789&creative=9325&node=13900871",
  },
  {
    name: "Health & Household",
    icon: BeakerIcon,
    description: "Wellness essentials",
    color: "bg-green-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=fda3198195bf49cce91738217b3bcdde&camp=1789&creative=9325&node=3760901",
  },
  {
    name: "Video Games",
    icon: MusicalNoteIcon,
    description: "Top-rated gaming picks",
    color: "bg-red-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=5d18fccfcf755112c71ebbf41c929859&camp=1789&creative=9325&node=979455011",
  },
  {
    name: "Mobile Devices",
    icon: DevicePhoneMobileIcon,
    description: "Phones & accessories",
    color: "bg-indigo-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=312df163f74137e901382a4658aff072&camp=1789&creative=9325&node=229677",
  },
];

const techGadgets = [
  {
    name: "Laptops",
    icon: ComputerDesktopIcon,
    description: "Portable powerhouses",
    color: "bg-slate-600",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=e0958114318874ce86a9db20df3f238e&camp=1789&creative=9325&node=565108",
  },
  {
    name: "Monitors",
    icon: TvIcon,
    description: "Crystal clear displays",
    color: "bg-cyan-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=30c1fc0bba862e98bea33c4ce5588d90&camp=1789&creative=9325&node=1292115011",
  },
  {
    name: "Routers",
    icon: WifiIcon,
    description: "Fast, reliable WiFi",
    color: "bg-teal-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=d6dde8ae10729be4bf4e524e76f5253b&camp=1789&creative=9325&node=300189",
  },
  {
    name: "Desktops",
    icon: HomeIcon,
    description: "Workstation warriors",
    color: "bg-orange-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=04ae16e0bdff7bfc17f60bbe643ddeb2&camp=1789&creative=9325&node=565098",
  },
  {
    name: "Cell Phones",
    icon: DevicePhoneMobileIcon,
    description: "Latest smartphones",
    color: "bg-rose-500",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=27cab6e6348e3bfa53eb881daeaa9173&camp=1789&creative=9325&node=7072561011",
  },
  {
    name: "Security Software",
    icon: ShieldCheckIcon,
    description: "Stay protected online",
    color: "bg-emerald-600",
    link: "https://www.amazon.com/b?_encoding=UTF8&tag=kjdii-20&linkCode=ur2&linkId=312df163f74137e901382a4658aff072&camp=1789&creative=9325&node=229677",
  },
];

function CategoryCard({ category }) {
  const Icon = category.icon;

  return (
    <a
      href={category.link}
      target="_blank"
      rel="noopener noreferrer nofollow sponsored"
      className="group card card-dark p-6 flex flex-col items-center text-center
                 hover:border-amazon-orange/50 hover:-translate-y-1 transition-all duration-300"
    >
      <div
        className={`${category.color} w-14 h-14 rounded-xl flex items-center justify-center mb-4
                    group-hover:scale-110 transition-transform duration-300`}
      >
        <Icon className="h-7 w-7 text-white" />
      </div>
      <h3 className="font-semibold text-gray-900 dark:text-white mb-1 group-hover:text-amazon-orange transition-colors">
        {category.name}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400">{category.description}</p>
    </a>
  );
}

function CategorySection({ title, description, categories, icon: Icon }) {
  return (
    <div className="mb-16 last:mb-0">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-amazon-orange/10 rounded-lg">
          <Icon className="h-6 w-6 text-amazon-orange" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">{title}</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((category) => (
          <CategoryCard key={category.name} category={category} />
        ))}
      </div>
    </div>
  );
}

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 sm:py-20 bg-gray-50 dark:bg-amazon-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Curated Categories
          </h2>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Browse our hand-picked selection of Amazon's best categories.
            Each link supports our affiliate program and helps you discover great products.
          </p>
        </div>

        <CategorySection
          title="Best Sellers"
          description="Top-rated products across popular categories"
          categories={bestSellers}
          icon={SparklesIcon}
        />

        <CategorySection
          title="Tech & Gadgets"
          description="The latest in technology and electronics"
          categories={techGadgets}
          icon={CpuChipIcon}
        />

        {/* Affiliate Disclosure */}
        <div className="mt-12 p-6 bg-amazon-dark-light/5 dark:bg-amazon-dark-lighter/30 rounded-xl border border-gray-200 dark:border-amazon-dark-lighter">
          <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
            <strong className="text-gray-700 dark:text-gray-300">Affiliate Disclosure:</strong>{" "}
            As an Amazon Associate, we earn from qualifying purchases. When you click our links
            and make a purchase, we may receive a small commission at no extra cost to you.
            This helps us keep the lights on and continue curating great deals for you!
          </p>
        </div>
      </div>
    </section>
  );
}
